import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AnchorHeadlineConverter extends CmsConverterService<AnchorHeadlineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      // TODO: Spartacus Upgrade - @Michael Latta
      // anchorHeadline: formData.st_subsection_headline ?? doNotTrack,
      anchorHeadline: formData.st_subsection_headline ?? '',
      icon: formData.st_icon?.value?.identifier ?? '',
      headlineOverride: formData.st_headline_override?.value ?? '',
      label: formData.st_icon?.value?.label ?? '',
      anchorOverride: formData.st_anchor_override?.value ?? ''
    }
  }
}

export const ANCHOR_HEADLINE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, AnchorHeadlineData>>('AnchorHeadlineConverter')

export interface AnchorHeadlineData extends ConvertedComponentData {
  anchorHeadline: TextInput;
  icon: string;
  label: string;
  headlineOverride: string;
  anchorOverride: string;
}
